import './ActionContainer.css';

type ActionContainerProps = {
  visible?: boolean,
  children?: React.ReactNode,
};

export default function ActionContainer(props: ActionContainerProps) {

  return (
    props.visible===true ?
    <div className='action-container'>
      {props.children}
    </div> : <></>
  )
}